// Simple event emitter implementation
export function createEventEmitter() {
  const listeners = {}

  return {
    on: (event, callback) => {
      if (!listeners[event]) listeners[event] = []
      listeners[event].push(callback)

      // Return unsubscribe function
      return () => {
        listeners[event] = listeners[event].filter((cb) => cb !== callback)
      }
    },

    emit: (event, data) => {
      if (!listeners[event]) return
      listeners[event].forEach((callback) => callback(data))
    },
  }
}
